var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUsersSelected = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.56977 3.55556C9.56977 5.24309 8.20175 6.61111 6.51421 6.61111C4.82668 6.61111 3.45866 5.24309 3.45866 3.55556C3.45866 1.86802 4.82668 0.5 6.51421 0.5C8.20175 0.5 9.56977 1.86802 9.56977 3.55556ZM12.2149 15.5H0.813535C1.06683 12.5738 3.52238 10.2778 6.51421 10.2778C9.50604 10.2778 11.9616 12.5738 12.2149 15.5Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUsersSelected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/usersSelected.287f47ddeee787982e091ccc36ae1ed0.svg";